<template>
  <div>
    <PageBanner :obj="obj"></PageBanner>
    <router-view></router-view>
  </div>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      obj: {
        cn: "CONTACT US",
        en: "CONTACT US",
        link: "/countact",
        image: "",
        list: [
          { name: "Talent Concept", link: "/countact/ln" },
          { name: "Recruiting", link: "/countact/zp" },
          { name: "Contact Us", link: "/countact/lx" },
        ],
      },
    };
  },
  methods: {
    async contactIndex() {
      let res = await service.contactIndex();
      this.obj.cn = res.data.banner.name;
      this.obj.en = res.data.banner.eng_title;
      this.obj.image = this.$baseURL + res.data.banner.thumb;
    },
  },
  created() {
    this.contactIndex();
  },
};
</script>

<style></style>